function thumbnail(src: string) {
  if (!src) return null;

  const imageArgs = 'w=250&h=250';

  if (src.charAt(src.length - 1) === '?') {
    return `${src}${imageArgs}`;
  }

  if (src.includes('fmt=auto')) {
    return `${src}&${imageArgs}`;
  }

  return `${src}?${imageArgs}`;
}

export default thumbnail;
